import Balloon from './component';
import {createElement, formatMoney, checkFavoriteList} from 'methods/utils';

function BalloonNearbyHotel(data, options) {
    Balloon.call(this, options);

    this.data = data;

    if (!this.data) {
        return;
    }

    this._setContent(createElement(this.createLayout()));
}

BalloonNearbyHotel.prototype = Object.create(Balloon.prototype);
Object.defineProperty(BalloonNearbyHotel.prototype, 'constructor', {
    value: BalloonNearbyHotel,
    enumerable: false,
    writable: true,
});

BalloonNearbyHotel.prototype.setData = function(data) {
    this.data = data;

    this._setContent(createElement(this.createLayout()));

    checkFavoriteList();
};

BalloonNearbyHotel.prototype.createLayout = function() {
    return this.data ? `
        <div class="Map__balloon_hotel-wrapper">
            <div class="Map__balloon_hotel-container">
                <div class="Map__balloon_hotel-item">
                    <div class="Map__balloon_hotel-left">
                        <div class="Map__balloon_hotel-image">
                            ${this._getPhotosHTML(this.data.photos, this.data.image_alt)}
                        </div>
                    </div>
                    <div class="Map__balloon_hotel-right">
                        <div class="Map__balloon_hotel-content">
                            <div class="Map__balloon_hotel-rating">
                                <div class="Map__balloon_hotel-rating-info">
                                    ${
                                        this.data.reviews_rating
                                            ? `
                                                <div class="Map__balloon_hotel-rating-block">
                                                    <div class="Map__balloon_hotel-rating-value">
                                                        <span>${this.data.reviews_rating_formatted}</span>
                                                    </div>
                                                </div>
                                            ` : ''
                                    }
                                    ${
                                        this.data.reviews_count && this.data.reviews_count > 0 && this.data.reviews_count_title
                                            ? `
                                                <div class="Map__balloon_hotel-review-block">
                                                    <div class="Map__balloon_hotel-review">
                                                        <span>${this.data.reviews_count} ${this.data.reviews_count_title}</span>
                                                    </div>
                                                </div>
                                            ` : `
                                                <div class="Map__balloon_hotel-review-block">
                                                    <div class="Map__balloon_hotel-review">
                                                        <span>Нет отзывов</span>
                                                    </div>
                                                </div>
                                            `
                                    }
                                </div>
                                <div class="Map__balloon_hotel-favorite">
                                    <span class="Map__balloon_hotel-favorite-item js-objectFavorite" data-id="${this.data.id}" title="Добавить в избранное">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M0 8.88595C0 5.09693 3.10038 2 6.89362 2C8.91634 2 10.747 2.85127 12 4.25509C13.253 2.85127 15.0837 2 17.1064 2C20.8996 2 24 5.09693 24 8.88595C24 10.6464 23.1963 12.3351 22.0964 13.8334C20.9906 15.3396 19.5329 16.7249 18.1021 17.8943C16.6674 19.0668 15.2366 20.0409 14.1665 20.7211C13.6308 21.0617 13.1836 21.3297 12.8692 21.5133C12.712 21.605 12.5878 21.6758 12.5023 21.7239C12.4595 21.748 12.4263 21.7665 12.4035 21.7791L12.3772 21.7936L12.3699 21.7976L12.3678 21.7987C12.3676 21.7989 12.3668 21.7993 12 21.1276C11.6309 21.798 11.6307 21.7979 11.6305 21.7978L11.6277 21.7963L11.6205 21.7923L11.5942 21.7777C11.5714 21.765 11.5383 21.7464 11.4955 21.7221C11.41 21.6736 11.2859 21.6024 11.1287 21.51C10.8144 21.3251 10.3674 21.0554 9.83172 20.7128C8.7619 20.0288 7.33143 19.05 5.89714 17.8745C4.46665 16.7021 3.00941 15.3156 1.90397 13.8124C0.804793 12.3177 0 10.6349 0 8.88595ZM12 21.1276L11.6305 21.7978L11.9985 22L12.3668 21.7993L12 21.1276ZM12.0014 20.2472C12.0314 20.2299 12.063 20.2115 12.0962 20.1921C12.3962 20.017 12.8267 19.759 13.3441 19.4301C14.3804 18.7714 15.7581 17.8328 17.132 16.71C18.5096 15.5841 19.8604 14.2914 20.8611 12.9285C21.8675 11.5576 22.4681 10.186 22.4681 8.88595C22.4681 5.94204 20.0536 3.53021 17.1064 3.53021C15.2222 3.53021 13.5772 4.46885 12.6462 5.93025L12 6.9446L11.3538 5.93025C10.4228 4.46885 8.77776 3.53021 6.89362 3.53021C3.94643 3.53021 1.53191 5.94204 1.53191 8.88595C1.53191 10.172 2.13138 11.5368 3.13859 12.9065C4.13952 14.2676 5.4908 15.5621 6.86882 16.6915C8.24304 17.8177 9.62108 18.7612 10.6576 19.4241C11.1752 19.755 11.6058 20.0148 11.9058 20.1912C11.9394 20.211 11.9713 20.2296 12.0014 20.2472Z"
                                                fill="#6A6D81"/>
                                        </svg>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M0 8.88595C0 5.09693 3.10038 2 6.89362 2C8.91634 2 10.747 2.85127 12 4.25509C13.253 2.85127 15.0837 2 17.1064 2C20.8996 2 24 5.09693 24 8.88595C24 10.6464 23.1963 12.3351 22.0964 13.8334C20.9906 15.3396 19.5329 16.7249 18.1021 17.8943C16.6674 19.0668 15.2366 20.0409 14.1665 20.7211C13.6308 21.0617 13.1836 21.3297 12.8692 21.5133C12.712 21.605 12.5878 21.6758 12.5023 21.7239C12.4595 21.748 12.4263 21.7665 12.4035 21.7791L12.3772 21.7936L12.3699 21.7976L12.3678 21.7987C12.3678 21.7987 12.3668 21.7993 12 21.1276C11.6309 21.798 11.6305 21.7978 11.6305 21.7978L11.6277 21.7963L11.6205 21.7923L11.5942 21.7777C11.5714 21.765 11.5383 21.7464 11.4955 21.7221C11.41 21.6736 11.2859 21.6024 11.1287 21.51C10.8144 21.3251 10.3674 21.0554 9.83172 20.7128C8.7619 20.0288 7.33143 19.05 5.89714 17.8745C4.46665 16.7021 3.00941 15.3156 1.90397 13.8124C0.804793 12.3177 0 10.6349 0 8.88595ZM12 21.1276L11.6305 21.7978L11.9985 22L12.3668 21.7993L12 21.1276Z"
                                                fill="#FF1F6B"/>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div class="Map__balloon_hotel-description">
                                <div class="Map__balloon_hotel-text Map__balloon_hotel-text-title">
                                    <a href="${this.data.url}" target="_blank" title="${this.data.title}">${this.data.title}</a>
                                </div>
                                <div class="Map__balloon_hotel-address Map__balloon_hotel-text-title">
                                    <span>${this.data.city_title}</span>
                                </div>
                            </div>
                            <div class="Map__balloon_hotel-distance-wrapper">
                                <div class="Map__balloon_hotel-distance">
                                    ${this.data.distance_title}
                                </div>
                            </div>
                        </div>
                    <div class="Map__balloon_hotel-left">
                        <div class="Map__balloon_hotel-text Map__balloon_hotel-text-price">
                            <span class="Map__balloon_hotel-text" title="${this.data.price_title}">
                                <span>
                                    от ${formatMoney(this.data.min_price)} руб.&nbsp;
                                </span>
                                ${
                                    this.data.price_title
                                        ? `
                                            <span class="Map__balloon_hotel-text-price-title">
                                                ${this.data.price_title}
                                            </span>
                                        ` : ''
                                }
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ` : '';
};

BalloonNearbyHotel.prototype._getPhotosHTML = function(photos, alt) {
    if (!photos || !photos.length) {
        return '';
    }

    const imageAlt = alt;

    const photosHTML = photos.map((photo) => {
        return `
            <div class="Map__balloon_hotel-slider-item">
                <a href="${this.data.url}">
                    <img src="${photo.photo}" alt="${imageAlt}">
                </a>
            </div>
        `;
    }).join('');

    return `
        <div class="Map__balloon_hotel-slider-block">
            <div class="Map__balloon_hotel-slider-wrapper">
                ${photosHTML}
            </div>
        </div>
    `;
};

export default BalloonNearbyHotel;